import runBatch from "../../utils/runBatch";

export default function markDiscussionChannelsAsRead(firebase, { user, discussionChannels }) {
	return runBatch(firebase, (batch) => {
		for (const channel of discussionChannels) {
			batch.update(channel.ref, {
				seenByUserIds: firebase.firestore.FieldValue.arrayUnion(user.id),
			});
		}
	});
}
